var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .arrow-icon__shape {\n        stroke: #000;\n        stroke-miterlimit: 10;\n      }\n    ")),React.createElement("polygon",{"className":"arrow-icon__shape","points":"0.81 0.5 125.35 0.5 492.42 500.5 125.34 1001 0.81 1000.5 249.34 501 0.81 0.5","key":1})]);
}

Arrow.defaultProps = {"className":"arrow-icon","data-name":"Layer 1","viewBox":"0 0 493.04 1001.5"};

module.exports = Arrow;

Arrow.default = Arrow;
